import { Box, Link, SpaceBetween } from '@cloudscape-design/components';
import { useNavigate } from 'react-router';

import { Device } from '../common/types';
import { useContext } from 'react';
import UserContext, { hasPermissions } from '../common/user';

export type DeviceLinkProps = {
  device: Device;
};

export function DeviceLink(props: DeviceLinkProps) {
  const { device } = props;
  const navigate = useNavigate();

  const { user } = useContext(UserContext);

  const canSeeDeviceLink = hasPermissions(user, ['orders.get']);

  const deviceLink = canSeeDeviceLink ? (
    <Link
      href={`/devices/${device.uuid}`}
      variant="secondary"
      onFollow={(e) => {
        e.preventDefault();
        navigate(`/devices/${device.uuid}`);
      }}
    >
      {device.device_id.trim()}
    </Link>
  ) : (
    <Box variant="span">{device.device_id.trim()}</Box>
  );

  const position_description = device.kiosk?.position_description ? (
    <Box variant="span">({device.kiosk?.position_description})</Box>
  ) : undefined;

  return (
    <SpaceBetween direction="horizontal" size="xs">
      {deviceLink}
      {position_description}
    </SpaceBetween>
  );
}
